<app-table [data]="operationTypes"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [headerBackgroundColor]="headerBackgroundColor"
           title="{{'admin.tickets.operation-types.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.tickets.operation-types.table.columns.name' | translate}}"
                      filterPlaceholder="{{'admin.tickets.operation-types.table.filter.name' | translate}}"
                      filter="true"
                      sortable="true"
                      field="name">
    </app-table-column>
    <app-table-column header="{{'admin.tickets.operation-types.table.columns.priority' | translate}}"
                      filterPlaceholder="{{'admin.tickets.operation-types.table.filter.priority' | translate}}"
                      [filter]="false"
                      [sortable]="false"
                      field="priority">
    </app-table-column>
</app-table>
